import { List } from 'immutable';

export default function getCurrentUserGroups(state: any) {
  return state.getIn(['currentUser', 'data', 'groupIds'], List()).toSet();
}
